import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { AvatarDialogComponent } from '../shared/avatar-dialog/avatar-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '../../../shared/snackbar/snackbar.service';
import { ConfigService } from '../../../../services/config.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
    firstName: string;
    lastName: string;
    role: string;
    avatar: string;

    supportUrl = '';

    constructor(
        public configService: ConfigService,
        private dialog: MatDialog,
        private translateService: TranslateService,
        private snackbarService: SnackbarService
    ) {}

    ngOnInit() {
        this.firstName = this.configService.me.name.firstName;
        this.lastName = this.configService.me.name.familyName;
        this.avatar = this.configService.me?.avatarLink;
        this.role =
            this.configService.me.businessRoles?.length > 0 ? this.configService.me.businessRoles[0] : undefined;

        const country = this.configService.me.company?.countryCode || this.configService.me.address?.countryCode;
        const language = this.configService.me.languageCode;

        const baseUrl = `${
            environment.globalHeader.partnerPortalBaseUrl
        }/${country.toLowerCase()}/${language.toLowerCase()}/`;

        const appId = environment.IAMConfig.auth.appId;

        this.supportUrl = `${baseUrl}support/faq/${appId}.html`;
    }

    openAvatarDialog(): void {
        const dialogRef = this.dialog.open(AvatarDialogComponent, {
            width: '600px',
            data: {
                avatar: this.avatar,
            },
        });

        dialogRef.afterClosed().subscribe((avatar) => {
            if (avatar !== undefined) {
                this.configService.me.avatarLink = avatar;
                this.avatar = avatar;

                this.snackbarService.open(
                    {
                        message: this.translateService.instant(
                            this.avatar
                                ? 'SELF_SERVICE.DASHBOARD.OVERVIEW.AVATAR.CHANGED_SUCCESSFULLY.MESSAGE'
                                : 'SELF_SERVICE.DASHBOARD.OVERVIEW.AVATAR.DELETED_SUCCESSFULLY.MESSAGE'
                        ),
                    },
                    { type: 'success' }
                );
            }
        });
    }
}
